import { render, staticRenderFns } from "./noPermissionInfo.vue?vue&type=template&id=e760d788&scoped=true"
import script from "./noPermissionInfo.vue?vue&type=script&lang=js"
export * from "./noPermissionInfo.vue?vue&type=script&lang=js"
import style0 from "./noPermissionInfo.vue?vue&type=style&index=0&id=e760d788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e760d788",
  null
  
)

export default component.exports